import React from 'react';
import { render } from 'react-dom';
import App from './App';

const target = document.querySelector('#root');

render(<App />, target);

if (module && module.hot) {
  module.hot.accept('./App', () => {
    /* eslint "global-require": "off" */
    const DevRoutes = require('./App').default;
    render(<DevRoutes />, target);
  });
}
